module.exports = __webpack_public_path__ + "img/nps-check-happy.0560e7be.svg";